import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
const HowWeWorksSection = ({ themeData }: any) => {
  return (
    <>
      {' '}
      <section className="howwe-section" id="how-work-section">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="section-title">
                <h2
                  style={{
                    color: `#${themeData?.theme_4?.home?.section_5?.h2color}`,
                  }}
                >
                  {themeData?.theme_4?.home?.section_5?.title}
                </h2>
                <p
                  style={{
                    color: `#${themeData?.theme_4?.home?.section_5?.paracolor}`,
                  }}
                >
                  {themeData?.theme_4?.home?.section_5?.paragraph}
                </p>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <Swiper
                spaceBetween={15}
                navigation={true}
                modules={[Navigation]}
                breakpoints={{
                  640: {
                    slidesPerView: 1,
                  },
                  768: {
                    slidesPerView: 4,
                  },
                  1024: {
                    slidesPerView: 4,
                  },
                }}
                className="home-slider home-slider-howwe"
              >
                {themeData?.theme_4?.home?.section_5?.card_section?.collection.map(
                  (items: any, index: any) => {
                    return (
                      <SwiperSlide>
                        <div className="card-howwe">
                          <div className="card-howwe-img">
                            <img src={items.icon} alt="" />
                            <span>{index + 1}</span>
                          </div>
                          <h3
                            style={{
                              color: `#${themeData?.theme_4?.home?.section_5?.h3color}`,
                            }}
                          >
                            {items.card_title}
                          </h3>
                          <p
                            style={{
                              color: `#${themeData?.theme_4?.home?.section_5?.paracolor}`,
                            }}
                          >
                            {items.card_paragraph}
                          </p>
                        </div>
                      </SwiperSlide>
                    );
                  }
                )}
              </Swiper>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default HowWeWorksSection;
